@if (impersonation(); as session) {
  <div class="impersonation-bar" role="status" data-toast-inset>
    <span class="material-icons-outlined">visibility</span>
    <span class="impersonation-text">
      Viewing as <strong>{{ session.name }}</strong> — read only. Nothing you do
      here can change anything.
    </span>
    <button
      type="button"
      class="impersonation-stop"
      (click)="stopImpersonating()"
    >
      Stop viewing
    </button>
  </div>
}

<router-outlet></router-outlet>
